import { createMuiTheme } from '@material-ui/core';

export const mainTheme = (direction: 'ltr' | 'rtl' = "ltr") => {
  return createMuiTheme({
    direction,
    palette: {
      primary: { light: '#39BAC0', main: '#108B9F', dark: '#108B9F', contrastText: '#ffffff' },
      secondary: { light: '#69A9C7', main: '#156F9B', dark: '#156F9B', contrastText: '#ffffff' }
    },
    props: {
      MuiButton: { disableElevation: true, variant: 'contained', color: 'secondary' },
      MuiAppBar: { elevation: 0 },
      MuiListItemText: { disableTypography: true },
      MuiTextField: { color: 'secondary' }
    },
    overrides: {
      MuiPaper: { elevation1: { boxShadow: '0 1px 1px rgba(0, 0, 0, .1)' } },
      MuiTextField: { root: {} },
      MuiListItemText: { root: { fontSize: '14px' } },
      MuiListSubheader: { root: { fontSize: '14px', color: '#2196f3', fontWeight: 400 } },
      MuiListItem: {
        root: {
          
        }
      }
    }
  });
};